<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">New enrollment interest</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Name</mat-label>
          <input matInput />
        </mat-form-field>
      </div>

      <div class="row">
        <div class="col-sm-4">
        <mat-form-field appearance="outline">
            <mat-label>Country code</mat-label>
            <mat-select>
              <mat-option value="india">India</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-8">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label> Phone	</mat-label>
          <input matInput  type="tel"/>
        </mat-form-field>
    </div>
      </div>
      
    

    
  
      <!-- <div class="mb-3_t">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Opted Timings	</mat-label>
            <input matInput name="selected_time_A"/>
            <mat-icon matSuffix style="margin-right: 4px;">
              access_time
            </mat-icon>
        </mat-form-field>
        </div> -->
      <div class="chip_cont" style="border-bottom: 1px solid #e7e7e7;">
        <div style="    margin-bottom: 18px;
        padding-bottom: 18px;
        border-bottom: 1px solid #e2e2e2;">
            <div class="close_heradinrt">
                <mat-icon>delete_outline</mat-icon>
            </div>
          <mat-chip-listbox aria-label="Fish selection" class="mb-3" >
            <mat-chip style="background: #ffc107; color: #fff;">Monday
            </mat-chip>
            <mat-chip style="background: #ffc107; color: #fff;">01:00 PM - 3:00 PM 
            </mat-chip>
          </mat-chip-listbox>
        </div>

        <div style="margin-bottom: 18px; padding-bottom: 3px;">
            <div class="close_heradinrt">
                <mat-icon>delete_outline</mat-icon>
            </div>
          <mat-chip-listbox aria-label="Fish selection" class="mb-3" >
            <mat-chip style="background: #ffc107; color: #fff;">Tuesday
            </mat-chip>
            <mat-chip style="background: #ffc107; color: #fff;">12:00 PM - 2:00 PM 
            </mat-chip>
          </mat-chip-listbox>
        </div>


        <!-- <div style="margin-bottom: 14px;">
          <mat-chip-list aria-label="Fish selection" class="mb-3">
            <mat-chip style="height: auto; background: #ffc107; color: #fff;"> Wednessday
            </mat-chip>
            <mat-chip style="height: auto; background: #ffc107; color: #fff;">02:00 PM - 4:00 PM
            </mat-chip>
          </mat-chip-list>
        </div> -->
        </div>

        <div class="another_btny">
            <button
            mat-flat-button
            color="accent">
       <mat-icon>add</mat-icon> Add a day
          </button>
        </div>
    
        <h3 class="shp-ser" style="padding-top: 20px; margin-bottom: 10px;">Shop Services</h3>
      <div class="chip_cont" style="margin-bottom: 8px;">
          <mat-chip-listbox aria-label="Fish selection" class="mb-3">
            <mat-chip
             
              class="selected">Hair color
            </mat-chip>
            <mat-chip
           
            class="selected">Bodu massage
          </mat-chip>
          <mat-chip
        
          class="selected">Hair cut
        </mat-chip>
        <mat-chip
       
        class="selected">Hair wash
      </mat-chip>
          </mat-chip-listbox>
        </div>

        <h3 class="shp-ser" style="padding-top: 20px; margin-bottom: 10px;">Job seleted</h3>
        <div style="margin-bottom: 24px;">
            <mat-chip-listbox aria-label="Fish selection" class="mb-3">
              <mat-chip style="background: #ffc107; color: #fff;">Accupuncture 
              </mat-chip>
              <mat-chip style="background: #ffc107; color: #fff;">Hair Shampoo
              </mat-chip>
            </mat-chip-listbox>
          </div>
      <div>
        
        <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Enrollment interest	</mat-label>
              <input matInput />
            </mat-form-field>
          </div>
    

        <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Cost</mat-label>
              <input matInput value="499" disabled />
            </mat-form-field>
          </div>



        <!-- <div class="afaf">
          <div class="mb-3_t">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Start Time		</mat-label>
            <input matInput name="selected_time_A"/>
            <mat-icon matSuffix style="margin-right: 4px;">
              access_time
            </mat-icon>
        </mat-form-field>
        </div>

        <div class="mb-3_t">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>End Time		</mat-label>
              <input matInput name="selected_time_A"/>
              <mat-icon matSuffix style="margin-right: 4px;">
                access_time
              </mat-icon>
          </mat-form-field>
          </div>
        </div> -->

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Notes</mat-label>
          <textarea matInput></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button style="color: #fff !important;"
          mat-flat-button
          color="accent">
        Create new interest
        </button>
      </mat-dialog-actions>